<template>
  <div id="ui-aside-wrapper" ref="uiaside" class="fixed top-0 left-0 w-full h-screen bg-gray-700 bg-opacity-0 z-50"  style="transition: all 800ms ease-in-out;" @click="clickOutside">
    <div  ref="content"  class="fixed top-0 right-0 bg-white w-full md:w-96 -right-96 h-screen" style="width: 700px;transition: all 800ms ease-in-out;">

      <div class="px-10 pt-10 pb-5 mb-5 bg-white border-b-2 border-gray-300">
        <h2 class="text-xl mb-1"><slot name="title"></slot></h2>
        <p class="text-gray-500 mb-2"><slot name="description"></slot></p>
      </div>

      <div class="px-10 max-w-xl overflow-y-auto" style="width:100%;max-width:100%;height:calc(100vh - 20rem);">
        <slot name="content"></slot>
      </div>

      <div class="absolute bottom-0 left-0 w-full">
        <slot name="footer"></slot>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  name: 'UiAside',

  props: {
  },
  data () {
    return {

    }
  },

  methods: {
    clickOutside (event) {
      if (event.target.getAttribute('id') === 'ui-aside-wrapper') {
        this.$refs.content.classList.add('-right-96')
        setTimeout(() => {
          this.$refs.uiaside.classList.add('bg-opacity-0')
          this.$refs.uiaside.classList.remove('bg-opacity-25')
        }, 600)

        setTimeout(() => {
          this.$emit('close')
          this.$destroy()
        }, 1200)
      }
    }
  },

  mounted () {
    this.$refs.uiaside.classList.add('bg-opacity-25')
    this.$refs.uiaside.classList.remove('bg-opacity-0')

    setTimeout(() => {
      this.$refs.content.classList.remove('-right-96')
    }, 200)
  }
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/ui/aside-layout.vue